import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from "./pages/About";
import Home from "./pages/Home";
import Layout from "./layout/Layout";
import { ParallaxProvider } from "react-scroll-parallax";
import Solutions from "./pages/Solutions";
import SolutionDetails from "./pages/SolutionDetails";
import Insights from "./pages/Insights";
import Article from "./pages/Article";
import Newsroom from "./pages/Newsroom";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Error404 from "./pages/Error404";
import Careers from "./pages/Careers";
import Team from "./pages/Team";
import Landing from "./pages/Landing";
import Thankyou from "./pages/Thankyou";
import FleetSense from "./pages/FleetSense";
import ComplimentingFleetModernization from "./pages/blogs/ComplimentingFleetModernization";
import CabInAlerts from "./pages/CabInAlerts";
import CabInVision from "./pages/CabInVision";
import RoadSense from "./pages/RoadSense";
import HappyDriverProgramme from "./pages/HappyDriverProgramme";
import EnvisioningFuture from "./pages/blogs/EnvisioningFuture";
import KapoorDiesel from "./pages/stories/KapoorDiesel";
import TruckDriverSafety from "./pages/blogs/TruckDriverSafety";
import LeverageAIS140 from "./pages/blogs/LeverageAIS140";
import BLRLogistics from "./pages/stories/BLRLogistics";
import TacklingDistractedDriving from "./pages/blogs/TacklingDistractedDriving";
import GovernmentRelations from "./pages/blogs/GovernmentRelations";
import EducationAndTraining from "./pages/blogs/EducationAndTraining";
import IndustryRelations from "./pages/blogs/IndustryRelations";
import MarutInsights from "./pages/MarutInsights";
import ShooraLifeSavers from "./pages/ShooraLifeSavers";
import ComingSoon from "./pages/ComingSoon";
import DeveloperAPI from "./pages/DeveloperAPI";
import CSR from "./pages/CSR";
import FAQsPage from "./pages/FAQsPage";
import CabinVisionDSM from "./pages/blogs/CabinVisionDSM";
import RoadSenseADAS from "./pages/blogs/RoadSenseADAS";
import { useEffect } from "react";
import SimpleLayout from "./layout/SimpleLayout";
import TermsOfUse from "./pages/legal/TermsOfUse";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import AccessibilityStatement from "./pages/legal/AccessibilityStatement";

const App = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <ParallaxProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />

            <Route path="/landing" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route
              path="/solutions/solution-details"
              element={<SolutionDetails />}
            />
            <Route path="/solutions/fleet-sense" element={<FleetSense />} />
            <Route path="/solutions/cabin-alerts" element={<CabInAlerts />} />
            <Route path="/solutions/cabin-vision" element={<CabInVision />} />
            <Route path="/solutions/road-sense" element={<RoadSense />} />
            <Route
              path="/solutions/marut-insights"
              element={<MarutInsights />}
            />
            <Route
              path="/solutions/shoora-life-savers"
              element={<ShooraLifeSavers />}
            />
            <Route
              path="/solutions/happy-driver-programme"
              element={<HappyDriverProgramme />}
            />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/article" element={<Article />} />
            <Route
              path="/insights/blog/complimenting-fleet-modernization-with-road-safety"
              element={<ComplimentingFleetModernization />}
            />
            <Route
              path="/insights/blog/envisioning-the-future-of-mobility-with-shoora"
              element={<EnvisioningFuture />}
            />
            <Route
              path="/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road"
              element={<TruckDriverSafety />}
            />
            <Route
              path="/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles"
              element={<LeverageAIS140 />}
            />
            <Route
              path="/insights/blog/tackling-distracted-driving-transforming-fleet-safety"
              element={<TacklingDistractedDriving />}
            />
            <Route
              path="/insights/blog/cabin-vision-dsm-cameras-redefining-fleet-safety-and-performance"
              element={<CabinVisionDSM />}
            />
            <Route
              path="/insights/blog/roadsense-adas-cameras-redefining-fleet-safety-and-performance"
              element={<RoadSenseADAS />}
            />
            <Route
              path="/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions"
              element={<KapoorDiesel />}
            />
            <Route
              path="/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents"
              element={<BLRLogistics />}
            />
            <Route path="/insights/:slug" element={<Article />} />
            <Route
              path="/government-relations"
              element={<GovernmentRelations />}
            />
            <Route
              path="/education-and-training"
              element={<EducationAndTraining />}
            />
            <Route path="/industry-relations" element={<IndustryRelations />} />
            <Route path="/developer-apis" element={<DeveloperAPI />} />
            <Route path="/csr-and-esg" element={<CSR />} />
            <Route path="/faqs" element={<FAQsPage />} />
            <Route path="/newsroom" element={<Newsroom />} />
            <Route path="/newsroom/news" element={<News />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/team" element={<Team />} />
            <Route path="/thank-you" element={<Thankyou />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/404" element={<Error404 />} />
            <Route path="*" element={<Error404 />} />
          </Route>
          <Route path="/legal" element={<SimpleLayout/>} >
            <Route path="/legal/terms-of-use" element={<TermsOfUse />} index />
            <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/legal/accessibility-statement" element={<AccessibilityStatement />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ParallaxProvider>
  );
};

export default App;
